export default __webpack_public_path__ + "static/media/plop.4a6ef345.mp3";